import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import CardTitle from "@saleor/components/CardTitle";
// import ControlledCheckbox from "@saleor/components/ControlledCheckbox";
import FormSpacer from "@saleor/components/FormSpacer";
import RadioGroupField, {
  RadioGroupFieldChoice
} from "@saleor/components/RadioGroupField";
import S3TextField from "@saleor/components/S3TextField";
import { commonMessages } from "@saleor/intl";
import { CreateProducttags_producttagsCreate_errors } from "@saleor/producttags/types/CreateProducttags";
import { ProductTagsTagType } from "@saleor/types/globalTypes";
import { getFormErrors } from "@saleor/utils/errors";
import React, { useEffect } from "react";
import { IntlShape, useIntl } from "react-intl";

import {
  ProductTagDetailsPageFormData,
  ProductTageDetailsPageTab
} from "../ProductTagsDetailsPage";

export interface ProductTagInfoProps {
  data: ProductTagDetailsPageFormData;
  disabled: boolean;
  errors: CreateProducttags_producttagsCreate_errors[];
  onChange: (event: React.ChangeEvent<any>) => void;
  onTabClick?: any;
  setNameValue?: (name, value) => void;
}
function createChoices(intl: IntlShape): RadioGroupFieldChoice[] {
  return [
    {
      label: intl.formatMessage({
        defaultMessage: "Text Tag",
        description: "Tag type"
      }),
      value: ProductTagsTagType.TEXT
    },
    {
      label: intl.formatMessage({
        defaultMessage: "Image Tag",
        description: "Tag type"
      }),
      value: ProductTagsTagType.IMAGE
    }
  ];
}

const ProductTagInfo: React.FC<ProductTagInfoProps> = ({
  data,
  disabled,
  errors,
  onChange,
  onTabClick,
  setNameValue
}) => {
  const intl = useIntl();

  const formErrors = getFormErrors(["title"], errors);

  const choices = createChoices(intl);
  useEffect(() => {
    if (data.tagType === ProductTagsTagType.TEXT) {
      if (onTabClick) {
        onTabClick(ProductTageDetailsPageTab.products);
      }
    }
  }, [data.tagType]);

  return (
    <Card>
      <CardTitle
        title={intl.formatMessage(commonMessages.generalInformations)}
      />

      <CardContent>
        <TextField
          disabled={disabled}
          name={"title" as keyof ProductTagDetailsPageFormData}
          error={!!formErrors.title}
          onChange={onChange}
          label={intl.formatMessage({
            defaultMessage: "Title",
            description: "productTag title"
          })}
          value={data.title}
          fullWidth
        />
        <FormSpacer />
        <RadioGroupField
          choices={choices}
          disabled={disabled}
          name={"tagType" as keyof ProductTagDetailsPageFormData}
          value={data.tagType}
          onChange={onChange}
        />
        <FormSpacer />

        {data.tagType === ProductTagsTagType.TEXT ? (
          <>
            <TextField
              disabled={disabled}
              name={"name" as keyof ProductTagDetailsPageFormData}
              onChange={onChange}
              label={intl.formatMessage({
                defaultMessage: "Name",
                description: "productTag name"
              })}
              value={data.name}
              fullWidth
            />
            <FormSpacer />
            <TextField
              disabled={disabled}
              name={"componentFontColor" as keyof ProductTagDetailsPageFormData}
              onChange={onChange}
              label={intl.formatMessage({
                defaultMessage: "Component Font Color",
                description: "Component Font Color"
              })}
              value={data.componentFontColor}
              fullWidth
            />
            <FormSpacer />
            <TextField
              disabled={disabled}
              name={"productFontColor" as keyof ProductTagDetailsPageFormData}
              onChange={onChange}
              label={intl.formatMessage({
                defaultMessage: "Product Font Color",
                description: "Product Font Color"
              })}
              value={data.productFontColor}
              fullWidth
            />
            <FormSpacer />
            <TextField
              disabled={disabled}
              name={
                "productBackgroundColor" as keyof ProductTagDetailsPageFormData
              }
              onChange={onChange}
              label={intl.formatMessage({
                defaultMessage: "Product Background Color",
                description: "Product Background Color"
              })}
              value={data.productBackgroundColor}
              fullWidth
            />
          </>
        ) : (
          // <TextField
          //   disabled={disabled}
          //   name={"stickersImage" as keyof ProductTagDetailsPageFormData}
          //   onChange={onChange}
          //   label={intl.formatMessage({
          //     defaultMessage: "Image",
          //     description: "stickersImage"
          //   })}
          //   value={data.stickersImage}
          //   fullWidth
          // />
          <S3TextField
            disabled={disabled}
            name={"stickersImage"}
            onChange={onChange}
            label={intl.formatMessage({
              defaultMessage: "Image",
              description: "stickersImage"
            })}
            value={data.stickersImage}
            setNameValue={setNameValue}
          />
        )}

        {/* <TextField
          disabled={disabled}
          name={"stickersImageLocationX" as keyof ProductTagDetailsPageFormData}
          onChange={onChange}
          label={intl.formatMessage({
            defaultMessage: "Image Loaction-X",
            description: "Image Loaction-X"
          })}
          value={data.stickersImageLocationX}
          fullWidth
        />
        <FormSpacer />
        <TextField
          disabled={disabled}
          name={"stickersImageLocationY" as keyof ProductTagDetailsPageFormData}
          onChange={onChange}
          label={intl.formatMessage({
            defaultMessage: "Image Loaction-Y",
            description: "Image Loaction-Y"
          })}
          value={data.stickersImageLocationY}
          fullWidth
        />
        <FormSpacer /> */}

        {/* <ControlledCheckbox
          name={"showTag" as keyof ProductTagDetailsPageFormData}
          label={intl.formatMessage({
            defaultMessage: "is Show Name",
            description: "showTag"
          })}
          checked={data.showTag}
          onChange={onChange}
          disabled={disabled}
        /> */}
      </CardContent>
    </Card>
  );
};
ProductTagInfo.displayName = "ProductTagInfo";
export default ProductTagInfo;
